import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Globals } from 'src/app/globals';

@Component({
  selector: 'app-entrada-numero',
  templateUrl: './entrada-numero.component.html',
  styleUrls: ['./entrada-numero.component.css']
})
export class EntradaNumeroComponent implements OnInit {

  @Input() parentForm:FormGroup;
  @Input() nombreControl:string;
  @Input() configCampo;
  @Input() valor;
  etiqueta;
  nombreCampo;
  control = new FormControl("", [Validators.required,Validators.min(0),Validators.max(100)]);

  constructor(private global:Globals) { }

  ngOnInit() {
    if(this.valor){
      this.control.setValue(this.valor);
    }
    this.parentForm.addControl(this.nombreControl,this.control);
    if(this.global.lenguaje=="es"){
      this.etiqueta = this.configCampo.es;
      this.nombreCampo = this.configCampo.es;
    }else{
      this.etiqueta = this.configCampo.en;
      this.nombreCampo = this.configCampo.en;
    }
  }

}
